// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-source-container {
  width: 100%;
  min-height: 90vh;
  background: var(--app-bg);
  padding: 32px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}

.data-source-content {
  max-width: 600px;
  width: 100%;
  background: var(--surface);
  border-radius: 12px;
  padding: 32px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border);
}

.header-section {
  text-align: center;
  margin-bottom: 32px;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 16px;
}

.page-subtitle {
  font-size: 1.125rem;
  color: var(--text-muted);
  margin: 0;
  font-weight: 500;
  max-width: 600px;
  margin: 0 auto;
}

.upload-section {
  margin-bottom: 24px;
}

.upload-zone {
  border: 2px dashed var(--border-strong);
  border-radius: 8px;
  padding: 40px 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--surface-2);
}

.upload-zone:hover {
  border-color: var(--primary);
  background: var(--surface-3);
}

.upload-zone.loading {
  border-color: var(--primary);
  background: var(--primary-soft);
}

.upload-zone.success {
  border-color: #10b981;
  background: #ecfdf5;
}

.upload-icon {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-icon svg {
  width: 48px;
  height: 48px;
  color: #3b82f6;
  transition: all 0.3s ease;
}

.spinner {
  animation: spin 1s linear infinite;
  color: #3b82f6;
}

.success-icon {
  color: #10b981;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.upload-text h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.upload-text p {
  font-size: 1rem;
  color: var(--text-muted);
  margin-bottom: 8px;
  font-weight: 500;
}

.browse-text {
  color: #667eea;
  font-weight: 600;
  text-decoration: underline;
}

.file-types {
  font-size: 0.875rem;
  color: var(--text-subtle);
  margin-top: 16px;
}

.file-info {
  margin-top: 24px;
  background: var(--surface);
  border-radius: 12px;
  padding: 20px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
}

.file-details {
  display: flex;
  align-items: center;
  gap: 16px;
}

.file-icon {
  color: #667eea;
  font-size: 24px;
}

.file-metadata {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-name {
  font-weight: 600;
  color: var(--text);
  font-size: 1rem;
}

.file-size {
  color: var(--text-muted);
  font-size: 0.875rem;
}


@media (max-width: 768px) {
  .data-source-container {
    margin-left: 0;
    padding: 12px;
  }

  .data-source-content {
    padding: 20px 16px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .upload-zone {
    padding: 28px 16px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/data-source/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,uFAAuF;EACvF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;;AAGA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".data-source-container {\n  width: 100%;\n  min-height: 90vh;\n  background: var(--app-bg);\n  padding: 32px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.data-source-content {\n  max-width: 600px;\n  width: 100%;\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 32px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border);\n}\n\n.header-section {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.page-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 16px;\n}\n\n.page-subtitle {\n  font-size: 1.125rem;\n  color: var(--text-muted);\n  margin: 0;\n  font-weight: 500;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.upload-section {\n  margin-bottom: 24px;\n}\n\n.upload-zone {\n  border: 2px dashed var(--border-strong);\n  border-radius: 8px;\n  padding: 40px 24px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: var(--surface-2);\n}\n\n.upload-zone:hover {\n  border-color: var(--primary);\n  background: var(--surface-3);\n}\n\n.upload-zone.loading {\n  border-color: var(--primary);\n  background: var(--primary-soft);\n}\n\n.upload-zone.success {\n  border-color: #10b981;\n  background: #ecfdf5;\n}\n\n.upload-icon {\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.upload-icon svg {\n  width: 48px;\n  height: 48px;\n  color: #3b82f6;\n  transition: all 0.3s ease;\n}\n\n.spinner {\n  animation: spin 1s linear infinite;\n  color: #3b82f6;\n}\n\n.success-icon {\n  color: #10b981;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.upload-text h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text);\n  margin-bottom: 8px;\n}\n\n.upload-text p {\n  font-size: 1rem;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.browse-text {\n  color: #667eea;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.file-types {\n  font-size: 0.875rem;\n  color: var(--text-subtle);\n  margin-top: 16px;\n}\n\n.file-info {\n  margin-top: 24px;\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n}\n\n.file-details {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.file-icon {\n  color: #667eea;\n  font-size: 24px;\n}\n\n.file-metadata {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.file-name {\n  font-weight: 600;\n  color: var(--text);\n  font-size: 1rem;\n}\n\n.file-size {\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\n\n@media (max-width: 768px) {\n  .data-source-container {\n    margin-left: 0;\n    padding: 12px;\n  }\n\n  .data-source-content {\n    padding: 20px 16px;\n  }\n\n  .page-title {\n    font-size: 1.5rem;\n  }\n\n  .upload-zone {\n    padding: 28px 16px;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
